import React from "react";
import "./Heading.css";
function Heading({headingTitle,underLined,position,color}) {
  return (
    <h2 className="heading2" data-position={position} data-color={color}>{headingTitle}<strong>{underLined}</strong></h2>
  );
}

export default Heading;